import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './FormTabs.module.css';

const FormTabs = ({
  className,
  rootClassName,
  tabs,
  activeTab,
  onTabChange,
  variant = 'underline',
}) => {
  const classes = classNames(rootClassName || css.root, className);
  const tabListRef = useRef(null);
  const [selectorStyle, setSelectorStyle] = useState({});

  useEffect(() => {
    if (tabListRef.current) {
      const activeTabElement = tabListRef.current.querySelector(`[data-tab-id="${activeTab}"]`);
      if (activeTabElement) {
        const { offsetLeft, offsetWidth } = activeTabElement;
        setSelectorStyle({
          left: offsetLeft,
          width: offsetWidth,
        });
      }
    }
  }, [activeTab, tabs]);

  return (
    <div className={classes}>
      <div ref={tabListRef} className={classNames(css.tabList, css[`tabList${variant}`])}>
        {/* Sliding selector */}
        <div 
          className={css.tabSelector}
          style={selectorStyle}
        />
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            data-tab-id={tab.id}
            className={classNames(css.tab, css[`tab${variant}`], {
              [css.tabActive]: tab.id === activeTab,
              [css[`tab${variant}Active`]]: tab.id === activeTab,
            })}
            onClick={() => onTabChange(tab.id)}
            aria-selected={tab.id === activeTab}
            role="tab"
          >
            {tab.icon && (
              <span className={css.tabIcon}>
                {typeof tab.icon === 'string' ? tab.icon : tab.icon}
              </span>
            )}
            <span className={css.tabLabel}>{tab.label}</span>
            {tab.hasChanges && <span className={css.changeIndicator} />}
          </button>
        ))}
      </div>
    </div>
  );
};

FormTabs.propTypes = {
  className: PropTypes.string,
  rootClassName: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.node,
      hasChanges: PropTypes.bool,
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['default', 'underline']),
};

export default FormTabs;